<template>
  <v-container fluid class="pa-0">
    <template v-if="false">
      <!-- Filtros -->
      <v-row class="mb-4">
        <v-col cols="12" md="3">
          <v-select
              v-model="filtros.idfilial"
              :items="filiaisFiltro"
              item-text="filial"
              item-value="idfilial"
              label="Filial"
              outlined
              dense
              clearable
              prepend-inner-icon="mdi-office-building"
              hide-details
          ></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <v-select
              v-model="filtros.grupoVeiculo"
              :items="gruposVeiculos"
              item-text="nome"
              item-value="id"
              label="Grupo de Veículo"
              outlined
              dense
              clearable
              prepend-inner-icon="mdi-truck"
              hide-details
          ></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <v-select
              v-model="filtros.periodo"
              :items="periodos"
              item-text="nome"
              item-value="valor"
              label="Período"
              outlined
              dense
              prepend-inner-icon="mdi-calendar"
              hide-details
          ></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <v-btn
              color="primary"
              @click="aplicarFiltros"
              block
              outlined
              height="40"
          >
            <v-icon left>mdi-filter</v-icon>
            Aplicar Filtros
          </v-btn>
        </v-col>
      </v-row>

      <!-- Cards de Resumo -->
      <v-row class="mb-4">
        <v-col cols="12" sm="6" md="3">
          <v-card class="elevation-3" color="primary" dark>
            <v-card-text>
              <div class="d-flex align-center">
                <div class="flex-grow-1">
                  <div class="text-h4 font-weight-bold">R$ {{ formatarMoeda(resumo.gastoTotal) }}</div>
                  <div class="text-subtitle-1">Gasto Total Mensal</div>
                </div>
                <v-icon size="48" class="ml-3">mdi-cash-multiple</v-icon>
              </div>
              <div class="mt-2">
                <v-chip
                    :color="resumo.variacaoGasto >= 0 ? 'red' : 'green'"
                    small
                    text-color="white"
                >
                  <v-icon small left>
                    {{ resumo.variacaoGasto >= 0 ? 'mdi-trending-up' : 'mdi-trending-down' }}
                  </v-icon>
                  {{ Math.abs(resumo.variacaoGasto) }}%
                </v-chip>
                <span class="ml-2 text-caption">vs mês anterior</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card class="elevation-3" color="success" dark>
            <v-card-text>
              <div class="d-flex align-center">
                <div class="flex-grow-1">
                  <div class="text-h4 font-weight-bold">{{ resumo.kmRodados.toLocaleString() }}</div>
                  <div class="text-subtitle-1">KM Rodados</div>
                </div>
                <v-icon size="48" class="ml-3">mdi-speedometer</v-icon>
              </div>
              <div class="mt-2">
                <v-chip color="white" small text-color="success">
                  <v-icon small left>mdi-calculator</v-icon>
                  R$ {{ (resumo.gastoTotal / resumo.kmRodados).toFixed(2) }}/km
                </v-chip>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card class="elevation-3" color="info" dark>
            <v-card-text>
              <div class="d-flex align-center">
                <div class="flex-grow-1">
                  <div class="text-h4 font-weight-bold">{{ resumo.veiculosAtivos }}</div>
                  <div class="text-subtitle-1">Veículos Ativos</div>
                </div>
                <v-icon size="48" class="ml-3">mdi-car-multiple</v-icon>
              </div>
              <div class="mt-2">
                <v-chip color="white" small text-color="info">
                  {{ resumo.disponibilidade }}% Disponível
                </v-chip>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card class="elevation-3" color="warning" dark>
            <v-card-text>
              <div class="d-flex align-center">
                <div class="flex-grow-1">
                  <div class="text-h4 font-weight-bold">{{ resumo.alertas }}</div>
                  <div class="text-subtitle-1">Alertas Pendentes</div>
                </div>
                <v-icon size="48" class="ml-3">mdi-alert-circle</v-icon>
              </div>
              <div class="mt-2">
                <v-chip color="red" small text-color="white" v-if="resumo.alertasUrgentes > 0">
                  {{ resumo.alertasUrgentes }} Urgentes
                </v-chip>
                <v-chip color="white" small text-color="warning" v-else>
                  Nenhum urgente
                </v-chip>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Alertas Importantes -->
      <v-row class="mb-4" v-if="alertasImportantes.length > 0">
        <v-col cols="12">
          <v-alert
              v-for="alerta in alertasImportantes"
              :key="alerta.id"
              :type="alerta.tipo"
              dismissible
              outlined
              class="mb-2"
          >
            <div class="d-flex align-center">
              <div class="flex-grow-1">
                <strong>{{ alerta.titulo }}</strong> - {{ alerta.descricao }}
              </div>
              <v-btn
                  color="primary"
                  outlined
                  small
                  @click="verDetalhesAlerta(alerta)"
              >
                Ver Detalhes
              </v-btn>
            </div>
          </v-alert>
        </v-col>
      </v-row>

      <!-- Gráficos Principais -->
      <v-row class="mb-4">
        <v-col cols="12" md="8">
          <v-card class="elevation-3">
            <v-card-title class="d-flex align-center">
              <v-icon class="mr-2">mdi-chart-line</v-icon>
              Evolução de Gastos por Categoria
              <v-spacer></v-spacer>
              <v-btn-toggle v-model="tipoGraficoGastos" mandatory>
                <v-btn small value="linha">
                  <v-icon>mdi-chart-line</v-icon>
                </v-btn>
                <v-btn small value="barra">
                  <v-icon>mdi-chart-bar</v-icon>
                </v-btn>
              </v-btn-toggle>
            </v-card-title>
            <v-card-text>
              <VueApexCharts
                  :options="opcoesGraficoGastos"
                  :series="seriesGraficoGastos"
                  :type="tipoGraficoGastos === 'linha' ? 'line' : 'bar'"
                  height="300"
              ></VueApexCharts>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card class="elevation-3">
            <v-card-title>
              <v-icon class="mr-2">mdi-pie-chart</v-icon>
              Distribuição de Gastos
            </v-card-title>
            <v-card-text>
              <VueApexCharts
                  :options="opcoesGraficoPizza"
                  :series="seriesGraficoPizza"
                  type="donut"
                  height="300"
              ></VueApexCharts>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Tabelas e Detalhes -->
      <v-row class="mb-4">
        <v-col cols="12" md="6">
          <v-card class="elevation-3">
            <v-card-title>
              <v-icon class="mr-2">mdi-gas-station</v-icon>
              Consumo por Tipo de Veículo
            </v-card-title>
            <v-card-text>
              <VueApexCharts
                  :options="opcoesGraficoConsumo"
                  :series="seriesGraficoConsumo"
                  type="bar"
                  height="250"
              ></VueApexCharts>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card class="elevation-3">
            <v-card-title>
              <v-icon class="mr-2">mdi-wrench</v-icon>
              Próximas Manutenções
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th>Veículo</th>
                    <th>Tipo</th>
                    <th>Vencimento</th>
                    <th>Status</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="manutencao in proximasManutencoes" :key="manutencao.id">
                    <td>{{ manutencao.veiculo }}</td>
                    <td>{{ manutencao.tipo }}</td>
                    <td>{{ formatarData(manutencao.vencimento) }}</td>
                    <td>
                      <v-chip
                          :color="getCorStatus(manutencao.status)"
                          small
                          text-color="white"
                      >
                        {{ manutencao.status }}
                      </v-chip>
                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Top Veículos por Gasto -->
      <v-row>
        <v-col cols="12">
          <v-card class="elevation-3">
            <v-card-title>
              <v-icon class="mr-2">mdi-trophy</v-icon>
              Top 10 Veículos por Gasto
              <v-spacer></v-spacer>
              <v-btn
                  v-if="false"
                  color="primary"
                  outlined
                  small
                  @click="exportarRelatorio"
              >
                <v-icon left>mdi-download</v-icon>
                Exportar
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-data-table
                  :headers="cabecalhosTabela"
                  :items="topVeiculos"
                  :items-per-page="10"
                  class="elevation-1"
                  @click:row="verDetalhesVeiculo"
              >
                <template v-slot:item.qtdabastecimento="{ item }">
                  {{ item.qtdabastecimento }}x
                </template>
                <template v-slot:item.kmrodados="{ item }">
                  {{ formatarKM(item.kmrodados) }}
                </template>
                <template v-slot:item.gastototal="{ item }">
                  <strong class="text-primary">R$ {{ formatarMoeda(item.gastototal) }}</strong>
                </template>
                <template v-slot:item.custokm="{ item }">
                  R$ {{ item.custokm.toFixed(2) }}
                </template>
                <template v-slot:item.status="{ item }">
                  <v-chip
                      :color="getCorStatus(item.status)"
                      small
                      text-color="white"
                  >
                    {{ item.status }}
                  </v-chip>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Dialog de Detalhes -->
      <v-dialog v-model="dialogDetalhes" max-width="800px">
        <v-card>
          <v-card-title>
            Detalhes do Veículo: {{ veiculoSelecionado.placa }}
          </v-card-title>
          <v-card-text>
            <!-- Conteúdo do dialog seria implementado aqui -->
            <p>Implementar detalhes específicos do veículo...</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialogDetalhes = false">
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <div class="dev-container">
        <!-- Partículas de fundo animadas -->
        <div class="particles">
          <div class="particle" v-for="n in 20" :key="n"></div>
        </div>

        <!-- Card principal -->
        <v-card class="dev-card elevation-2 card-visible">
          <v-card-text class="text-center pa-8">
            <!-- Ícone animado -->
            <div class="icon-container mt-8">
              <div class="construction-icon">🚧</div>
              <div class="gear-icon">⚙️</div>
            </div>

            <!-- Título -->
            <h2 class="title mb-4">
              Dashboard em Desenvolvimento
            </h2>

            <!-- Mensagem -->
            <p class="message mb-6">
              Os dados desta página estão sendo tratados e organizados para futura disponibilização.
            </p>
          </v-card-text>
        </v-card>
      </div>
    </template>
  </v-container>
</template>

<script>
import {mapState} from "vuex";
import VueApexCharts from "vue-apexcharts";
import axios from "axios";

export default {
  components: { VueApexCharts },
  data() {
    return {
      // Filtros
      filtros: {
        idfilial: null,
        grupoVeiculo: null,
        periodo: 'mensal'
      },
      filiais: [
        { id: 1, nome: 'Filial São Paulo' },
        { id: 2, nome: 'Filial Rio de Janeiro' },
        { id: 3, nome: 'Filial Belo Horizonte' }
      ],
      gruposVeiculos: [
        { id: 1, nome: 'Caminhões' },
        { id: 2, nome: 'Empilhadeiras' },
        { id: 3, nome: 'Carros' }
      ],
      periodos: [
        { nome: 'Mensal', valor: 'mensal' },
        { nome: 'Trimestral', valor: 'trimestral' },
        { nome: 'Anual', valor: 'anual' }
      ],

      // Dados de resumo
      resumo: {
        gastoTotal: 125450.00,
        variacaoGasto: -5.2,
        kmRodados: 45280,
        veiculosAtivos: 48,
        disponibilidade: 92,
        alertas: 7,
        alertasUrgentes: 2
      },

      // Alertas importantes
      alertasImportantes: [
        {
          id: 1,
          tipo: 'error',
          titulo: 'Manutenção Vencida',
          descricao: 'Caminhão ABC-1234 com revisão vencida há 15 dias'
        },
        {
          id: 2,
          tipo: 'warning',
          titulo: 'Consumo Elevado',
          descricao: '3 veículos com consumo 20% acima da média'
        }
      ],

      // Configurações dos gráficos
      tipoGraficoGastos: 'linha',

      // Dados para gráfico de gastos
      seriesGraficoGastos: [
        {
          name: 'Combustível',
          data: [30000, 35000, 32000, 38000, 35000, 40000]
        },
        {
          name: 'Manutenção',
          data: [15000, 18000, 22000, 16000, 19000, 21000]
        },
        {
          name: 'Pneus',
          data: [8000, 12000, 9000, 11000, 13000, 10000]
        },
        {
          name: 'Serviços',
          data: [12000, 14000, 13000, 15000, 16000, 14500]
        }
      ],

      opcoesGraficoGastos: {
        chart: {
          id: 'gastos-evolucao',
          toolbar: { show: true }
        },
        xaxis: {
          categories: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun']
        },
        colors: ['#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4'],
        stroke: { width: 3 },
        dataLabels: { enabled: false },
        legend: { position: 'top' }
      },

      // Dados para gráfico pizza
      seriesGraficoPizza: [45, 25, 15, 15],
      opcoesGraficoPizza: {
        labels: ['Combustível', 'Manutenção', 'Pneus', 'Serviços'],
        colors: ['#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4'],
        legend: { position: 'bottom' },
        plotOptions: {
          pie: {
            donut: {
              size: '70%',
              labels: {
                show: true,
                total: {
                  show: true,
                  label: 'Total',
                  formatter: () => 'R$ 125.450'
                }
              }
            }
          }
        }
      },

      // Dados para gráfico de consumo
      seriesGraficoConsumo: [{
        name: 'Consumo (L/100km)',
        data: [35, 12, 8]
      }],
      opcoesGraficoConsumo: {
        chart: { id: 'consumo-veiculos' },
        xaxis: {
          categories: ['Caminhões', 'Empilhadeiras', 'Carros']
        },
        colors: ['#FFA726'],
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: { position: 'top' }
          }
        }
      },

      // Próximas manutenções
      proximasManutencoes: [
        {
          id: 1,
          veiculo: 'ABC-1234',
          tipo: 'Revisão',
          vencimento: '2025-06-05',
          status: 'Vencido'
        },
        {
          id: 2,
          veiculo: 'DEF-5678',
          tipo: 'Troca de óleo',
          vencimento: '2025-06-10',
          status: 'Próximo'
        },
        {
          id: 3,
          veiculo: 'GHI-9012',
          tipo: 'Pneus',
          vencimento: '2025-06-15',
          status: 'Programado'
        }
      ],

      // Top veículos
      cabecalhosTabela: [
        { text: 'Placa', value: 'placa' },
        { text: 'Tipo', value: 'tipo' },
        { text: 'Filial', value: 'empresa' },
        { text: 'KM Rodados', value: 'kmrodados' },
        { text: 'Gasto Total', value: 'gastototal' },
        { text: 'Custo/KM', value: 'custokm' },
        { text: 'Qtde Abast.', value: 'qtdabastecimento' },
        { text: 'Status', value: 'status' }
      ],
      topVeiculos: [
        {
          placa: 'ABC-1234',
          tipo: 'Caminhão',
          filial: 'Maringá',
          km: 15420,
          gasto: 8750.00,
          custoPorKm: 0.57,
          status: 'Ativo'
        },
        {
          placa: 'DEF-5678',
          tipo: 'Caminhão',
          filial: 'São Mateus',
          km: 12850,
          gasto: 7200.00,
          custoPorKm: 0.56,
          status: 'Ativo'
        },
        // Mais dados...
      ],

      // Dialog
      dialogDetalhes: false,
      veiculoSelecionado: {}
    }
  },
  computed: {
    ...mapState(["backendUrl", "usuario"]),
    filiaisFiltro() {
      if (this.filiais.lista) {
        return this.filiais.lista.filter((v) => {
          return (
              v.idfilial !== 6 &&
              v.idfilial !== 12 &&
              v.idfilial !== 25 &&
              v.idfilial !== 29 &&
              v.idfilial !== 33 &&
              v.idfilial !== 37
          );
        });
      } else {
        return [];
      }
    },
  },
  methods: {
    aplicarFiltros() {
      // Implementar lógica de filtros
      console.log('Aplicando filtros:', this.filtros);
    },

    formatarMoeda(valor) {
      return valor.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    formatarKM(valor) {
      if (valor == null) return '-'

      const apenasNumeros = String(valor).replace(/\D/g, '')

      const comZeros = apenasNumeros.padStart(6, '0')

      return comZeros.replace(/(\d{3})(\d{3})/, '$1.$2')
    },

    formatarData(data) {
      return new Date(data).toLocaleDateString('pt-BR');
    },

    getCorStatus(status) {
      const cores = {
        'Vencido': 'red',
        'Próximo': 'orange',
        'Programado': 'green',
        'Ativo': 'success',
        'Manutenção': 'warning'
      };
      return cores[status] || 'grey';
    },

    verDetalhesAlerta(alerta) {
      console.log('Ver detalhes do alerta:', alerta);
    },

    verDetalhesVeiculo(veiculo) {
      this.veiculoSelecionado = veiculo;
      this.dialogDetalhes = true;
    },

    exportarRelatorio() {
      console.log('Exportando relatório...');
    },

    async teste1(){
      try {
        const response = await axios.post(`${this.backendUrl}tms/dash/top/listar`, {});

        if (response.data && Array.isArray(response.data)) {
          this.topVeiculos = response.data
          console.log(response.data)
        } else {
          console.log('sem dados')
        }
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
      }
    },

    async teste2(){
      try {
        const response = await axios.post(`${this.backendUrl}tms/dash/consumo/veiculo/listar`, {});

        if (response.data && Array.isArray(response.data)) {
          console.log(response.data)
        } else {
          console.log('sem dados')
        }
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
      }
    },

    async teste3(){
      try {
        const response = await axios.post(`${this.backendUrl}tms/dash/card/listar`, {});

        if (response.data && Array.isArray(response.data)) {
          console.log(response.data)
        } else {
          console.log('sem dados')
        }
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
      }
    }
  },

  mounted() {
    // this.teste1();
    // this.teste2();
    // this.teste3();
    // Carregar dados iniciais
    // this.aplicarFiltros();
  }
};
</script>

<style scoped>
.v-card {
  border-radius: 12px;
}

.elevation-3 {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1) !important;
}

.text-h4 {
  font-weight: 700;
}

.v-chip {
  font-weight: 600;
}

.v-data-table tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
  cursor: pointer;
}



.dev-container {
  min-height: 65vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(8, 47, 73, 0.15) 0%, rgba(12, 74, 110, 0.3) 100%);
  padding: 20px;
  position: relative;
  overflow: hidden;
}

/* Partículas de fundo */
.particles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.particle {
  position: absolute;
  width: 4px;
  height: 4px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  animation: float 6s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
    opacity: 1;
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
    opacity: 0.7;
  }
}

/* Card principal */
.dev-card {
  background: rgba(255, 255, 255, 0.95) !important;
  border-radius: 20px !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 500px;
  width: 100%;
  transform: translateY(50px);
  opacity: 0;
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.dev-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  transition: left 0.5s;
}

.dev-card:hover::before {
  left: 100%;
}

.card-visible {
  transform: translateY(0);
  opacity: 1;
}

/* Ícones animados */
.icon-container {
  position: relative;
  height: 80px;
  margin-bottom: 12px;
}

.construction-icon {
  font-size: 4rem;
  display: inline-block;
  animation: bounce 2s infinite;
}

.gear-icon {
  position: absolute;
  top: -10px;
  right: calc(50% - 80px);
  font-size: 2rem;
  animation: rotate 4s linear infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Texto */
.title {
  font-size: 2rem;
  font-weight: 600;
  color: #2c3e50;
  font-family: 'Roboto', sans-serif;
}

/* Mensagem */
.message {
  font-size: 1.1rem;
  color: #546e7a;
  line-height: 1.6;
  margin: 0;
}

/* Responsividade */
@media (max-width: 600px) {
  .dev-card {
    margin: 16px;
    max-width: none;
  }

  .title {
    font-size: 1.6rem;
  }

  .message {
    font-size: 1rem;
  }

  .construction-icon {
    font-size: 3rem;
  }

  .gear-icon {
    font-size: 1.5rem;
  }
}
</style>